import { useTranslation } from 'react-i18next';
import type { ShipmentStatus } from '../../models/shipmentStatusMapping.types';

interface MappingStatusBadgeProps {
  shipmentStatus: ShipmentStatus | null;
}

export const MappingStatusBadge = ({ shipmentStatus }: MappingStatusBadgeProps) => {
  const { t } = useTranslation('shipmentStatusMappingModule');

  return (
    <span
      className="inline-flex max-w-[7rem] shrink-0 truncate rounded-full border border-border bg-muted/40 px-2.5 py-1 text-center text-xs font-medium text-foreground sm:max-w-[9rem]"
      title={shipmentStatus?.name ?? t('shipmentStatusMapping.table.noMapped')}
    >
      {shipmentStatus?.name ?? t('shipmentStatusMapping.table.noMapped')}
    </span>
  );
};
